var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwapArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 8,
    viewBox: "0 0 230 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.646447 3.47311C0.451184 3.66837 0.451184 3.98495 0.646447 4.18021L3.82843 7.36219C4.02369 7.55746 4.34027 7.55746 4.53553 7.36219C4.7308 7.16693 4.7308 6.85035 4.53553 6.65509L1.70711 3.82666L4.53553 0.998233C4.7308 0.802971 4.7308 0.486388 4.53553 0.291126C4.34027 0.0958641 4.02369 0.0958641 3.82843 0.291126L0.646447 3.47311ZM229.354 4.18021C229.549 3.98495 229.549 3.66837 229.354 3.47311L226.172 0.291126C225.976 0.0958641 225.66 0.0958641 225.464 0.291126C225.269 0.486388 225.269 0.802971 225.464 0.998233L228.293 3.82666L225.464 6.65509C225.269 6.85035 225.269 7.16693 225.464 7.36219C225.66 7.55746 225.976 7.55746 226.172 7.36219L229.354 4.18021ZM1 3.82666V4.32666H229V3.82666V3.32666H1V3.82666Z",
    fill: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapArrow);
export default __webpack_public_path__ + "static/media/swap-arrow.3fe2bc60b27ff5a04b9875b724ef07af.svg";
export { ForwardRef as ReactComponent };